import { cn } from "~/lib/utils";
import Paragraph from "~/componentsDS/Typography/Paragraph";

export const DOSE_ADJUSTMENT_NOTE = "*Dose adjustments may incur an additional cost.";

type Props = {
    className?: string;
};

const DoseAdjustmentNote = ({ className }: Props) => (
    <Paragraph size="sm" className={cn("text-pureWhite", className)}>
        {DOSE_ADJUSTMENT_NOTE}
    </Paragraph>
);

export default DoseAdjustmentNote;
